var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xA1\xA8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M46.3852 4.51407H19.0125C13.5211 4.51407 9.07739 8.96485 9.07739 14.4492V57.5438C9.07739 63.0352 13.5282 67.4789 19.0125 67.4789H53.1493C58.6407 67.4789 63.0844 63.0281 63.0844 57.5438V21.2133C63.0844 18.9774 62.1985 16.8328 60.6165 15.2438L52.3547 6.98204C50.7727 5.40001 48.6211 4.51407 46.3852 4.51407V4.51407Z",
    fill: "#B5CCED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M60.6164 15.2437L52.3546 6.98203C51.1593 5.78672 49.6476 4.99218 48.0164 4.66875V13.943C48.0164 16.8891 50.4 19.2727 53.346 19.2727H62.8593C62.5007 17.7609 61.7343 16.3617 60.6164 15.2437Z",
    fill: "#8CB1E4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xA1\xA8\xE5\x8D\x95 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M48.25 45.75C48.25 46.413 47.9866 47.0489 47.5178 47.5178C47.0489 47.9866 46.413 48.25 45.75 48.25H28.25C27.587 48.25 26.9511 47.9866 26.4822 47.5178C26.0134 47.0489 25.75 46.413 25.75 45.75V28.25C25.75 27.587 26.0134 26.9511 26.4822 26.4822C26.9511 26.0134 27.587 25.75 28.25 25.75H45.75C46.3807 25.7498 46.9882 25.988 47.4507 26.4169C47.9132 26.8457 48.1964 27.4336 48.2438 28.0625L48.25 28.25V45.75V45.75ZM33.25 42H28.25V45.75H33.25V42ZM39.5 42H34.5V45.75H39.5V42ZM45.75 42H40.75V45.75H45.75V42ZM33.25 37H28.25V40.75H33.25V37ZM39.5 37H34.5V40.75H39.5V37ZM45.75 37H40.75V40.75H45.75V37ZM33.25 32H28.25V35.75H33.25V32ZM39.5 32H34.5V35.75H39.5V32ZM45.75 32H40.75V35.75H45.75V32Z",
    fill: "#8CB1E4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xA1\xA8\xE5\x8D\x95 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M47.25 44.75C47.25 45.413 46.9866 46.0489 46.5178 46.5178C46.0489 46.9866 45.413 47.25 44.75 47.25H27.25C26.587 47.25 25.9511 46.9866 25.4822 46.5178C25.0134 46.0489 24.75 45.413 24.75 44.75V27.25C24.75 26.587 25.0134 25.9511 25.4822 25.4822C25.9511 25.0134 26.587 24.75 27.25 24.75H44.75C45.3807 24.7498 45.9882 24.988 46.4507 25.4169C46.9132 25.8457 47.1964 26.4336 47.2438 27.0625L47.25 27.25V44.75V44.75ZM32.25 41H27.25V44.75H32.25V41ZM38.5 41H33.5V44.75H38.5V41ZM44.75 41H39.75V44.75H44.75V41ZM32.25 36H27.25V39.75H32.25V36ZM38.5 36H33.5V39.75H38.5V36ZM44.75 36H39.75V39.75H44.75V36ZM32.25 31H27.25V34.75H32.25V31ZM38.5 31H33.5V34.75H38.5V31ZM44.75 31H39.75V34.75H44.75V31Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/表.7e19e143a1229302eb1a2cde6364e903.svg";
export { ForwardRef as ReactComponent };